import React, { useState, forwardRef, useImperativeHandle } from "react";


const SimpleTextRenderer = forwardRef((props, ref) => {
    return (
        <span>
            <span className="editableCell">{props.value  ? props.value : <div><span className="addtext"></span><div className="addtextafter"><i className="fa fa-plus"></i></div></div>}</span>
        </span>
    );
});

export default SimpleTextRenderer;


